import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { LOADING, IDLE, ERROR } from '../../../../store/selectors.ts';
import { FormGroup, Type, FormSelect } from '@spotify-internal/encore-creator-web';
import { trackEvent } from '../../../../lib/Tracking';
import { PodcastModalBody } from '../../../Shared/PodcastModal/index.tsx';
import { FormattedMessage, defineMessage } from 'react-intl';

export class PodcastUpdateLicensor extends PureComponent {
  static propTypes = {
    currentLicensor: PropTypes.string,
    aggregators: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.name,
      }),
    ),
    suggestedNetworkId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    status: PropTypes.oneOf([LOADING, IDLE, ERROR]),
    intl: PropTypes.shape(),
  };

  componentDidMount() {
    trackEvent({
      category: 'feed-update',
      action: 'licensor',
      label: 'start',
    });
  }

  render() {
    const selectMessage = defineMessage({
      id: 'podcast-update.update-licensor-select',
      defaultMessage: 'Choose one',
    });
    return (
      <Fragment>
        <PodcastModalBody data-qa="rss-verification-form">
          <Type as="h1" variant={Type.heading2}>
            <FormattedMessage
              id="podcast-update.update-licensor-title"
              defaultMessage="Confirm your hosting provider"
            />
          </Type>
          <Type as="p">
            <FormattedMessage
              id="podcast-update.update-licensor-description"
              defaultMessage="Selecting your hosting provider will ensure that you’ll see Spotify analytics on your host’s dashboard."
            />
          </Type>
          <FormGroup
            label={
              <FormattedMessage
                id="podcast-update.update-licensor-title-2"
                defaultMessage="Hosting provider"
              />
            }
            labelFor="podcastLicensor"
          >
            <FormSelect
              id="podcastLicensor"
              data-testid="podcast-licensor"
              defaultValue={this.props.suggestedNetworkId}
              onChange={this.props.onChange}
              error={this.props.status === ERROR}
            >
              <option disabled value="">
                {this.props.intl.formatMessage(selectMessage)}
              </option>
              {this.props.aggregators.map(l => (
                <option key={l.id} value={l.id}>
                  {l.name}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
          {this.props.status === ERROR && (
            <Type as="p" data-testid="passthrough-failure" color={'failure'} variant={Type.sm}>
              <FormattedMessage
                id="podcast-update.update-licensor-passthough-fail"
                defaultMessage="This hosting provider has specific requirements that are not met by this RSS feed.
                  {linebreak}
                  Please contact them for more details on what needs to be updated before making this change."
                values={{
                  linebreak: <br />,
                }}
              />
            </Type>
          )}
        </PodcastModalBody>
      </Fragment>
    );
  }
}
